// extracted by mini-css-extract-plugin
module.exports = {"input":"Rfc9zzbD mx-auto col-12 md-col-5 lg-col-4 mt2 mb2"};